var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('ul',{staticClass:"list"},_vm._l((_vm.allTasks),function(task){return _c('li',{key:task.id},[_c('TaskItem',{staticClass:"task",attrs:{"info":task}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }